import { useRef, useState } from 'react';
import { Button } from './Button.tsx';

/** The copyable registration-ID box, shared by the registration success screen and the ID-lookup page. */
export function CandidateIdBox({ id, name }: { id: string; name?: string }) {
  const [copied, setCopied] = useState(false);
  const idRef = useRef<HTMLElement>(null);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(id);
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    } catch {
      const r = document.createRange();
      if (idRef.current) {
        r.selectNodeContents(idRef.current);
        const s = getSelection();
        s?.removeAllRanges();
        s?.addRange(r);
      }
    }
  };
  return (
    <div className='candidate-id-box'>
      {name && <div className='candidate-id-box__name'>{name}</div>}
      <div className='label'>आपला नोंदणी आयडी</div>
      <code className='value' ref={idRef}>{id}</code>
      <Button variant='secondary' size='sm' icon={copied ? 'check' : 'copy'} onClick={copy}>
        {copied ? 'कॉपी झाला' : 'आयडी कॉपी करा'}
      </Button>
    </div>
  );
}
